import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../components/MaterialTypography";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import { useEffect, useState } from "react";
import MaterialSelect from "../../../../components/MasterSelect";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import {
  allProducts,
  createSampleMutation,
  getSampleDataById,
  todayCustomers,
  updateSampleMutation,
} from "../graphQL";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/LodingContext";
import { todayCustomersDropdown } from "../../report/ReportData";

const SampleForm = () => {
  const location = useLocation();
  const formType = location?.state?.type;
  const rowId = location?.state?.rowId;

  const navigate = useNavigate();
  const { userId } = useAuthData();
  const { setCirleLoading } = useLoading();
  const [inputDisable, setInputDisable] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [sampleData, setSampleData] = useState({
    productName: "",
    customerName: "",
    sampleDate: "",
    quantity: "",
  });

  //UseEffect to set Page type
  useEffect(() => {
    if (formType == "view") {
      setInputDisable(true);
    } else {
      setInputDisable(false);
    }
  }, [formType]);

  //Fetch Product List
  useEffect(() => {
    const fetchProduct = async () => {
      setCirleLoading(true);
      try {
        const response = await request(BASEURL, allProducts);
        const products = response?.allProducts?.data;
        const options = products?.map((product) => ({
          label: product.productName,
          value: product.id,
        }));
        setProductOptions(options);
      } catch (error) {
        console.error("Error Fetching Product:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    const fetchCustomer = async () => {
      setCirleLoading(true);
      try {
        const response = await request(BASEURL, todayCustomersDropdown);
        console.log(response,"response");
        
        const reponseData = response.todayCustomersDropdown?.data;
        const allCustomers = reponseData?.map((index) => ({
          label: index.customerName,
          value: index.id,
        }));
        setCustomerOptions(allCustomers);
      } catch (error) {
        console.error("Error Fetching data", error);
      } finally {
        setCirleLoading(false);
      }
    };
    fetchProduct();
    fetchCustomer();
  }, []);

  //To fetch Sample Data By ID
  useEffect(() => {
    const fetchSampleDataById = async () => {
      if (!rowId) return;
      try {
        setCirleLoading(true);
        const response = await request(BASEURL, getSampleDataById, {
          id: rowId,
        });
        const responseData = response.getProductSampleById.data?.[0];
        if (responseData) {
          setSampleData((prev) => ({
            ...prev,
            productName: {
              label: responseData?.product?.productName,
              value: responseData?.product?.id,
            },
            customerName: {
              label: responseData?.customer?.customerName,
              value: responseData?.customer?.id,
            },
            sampleDate: responseData.sampleProvidedDate,
            quantity: responseData.quantityProvided,

            productNameStatus: "success",
            customerNameStatus: "success",
            sampleDateStatus: "success",
            quantityStatus: "success",
          }));
        }
      } catch (error) {
        console.error("Error Fetching data", error);
      } finally {
        setCirleLoading(false);
      }
    };
    fetchSampleDataById();
  }, [rowId]);

  //Create Mutation
  const handleSubmitSample = async () => {
    setCirleLoading(true);
    try {
      const values = {
        productId: sampleData.productName.value,
        customerId: sampleData.customerName.value,
        sampleProvidedDate: sampleData.sampleDate,
        quantityProvided: sampleData.quantity,
        createdById: userId,
      };
      const response = await request(BASEURL, createSampleMutation, {
        input: values,
      });
      const successStatus = response.createProductSample.success;
      const responseMessage = response.createProductSample.message;
      if (successStatus) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: responseMessage,
          showConfirmButton: true,
        }).then(() => {
          navigate("/samples-and-feedback");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: responseMessage,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error Submitting Data: ", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //Edit Mutation
  const handleEditSample = async () => {
    setCirleLoading(true);
    try {
      const values = {
        id: rowId,
        productId: sampleData?.productId?.value,
        customerId: sampleData?.customerName?.value,
        sampleProvidedDate: sampleData.sampleDate,
        quantityProvided: sampleData.quantity,
        createdById: userId,
      };
      const response = await request(BASEURL, updateSampleMutation, {
        input: values,
      });

      const successStatus = response.updateProductSample.success;
      const responseMessage = response.updateProductSample.message;
      if (successStatus) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: responseMessage,
          showConfirmButton: true,
        }).then(() => {
          navigate("/samples-and-feedback");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: responseMessage,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error Submiting Data", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //Handle Change
  const handleSampleForm = (event, selectEvent) => {
    let sampleState = { ...sampleData };
    //DropDown
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "productName": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            sampleState[selectEvent.name + "Status"] = "success";
          } else {
            sampleState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          break;
        }

        case "customerName": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            sampleState[selectEvent.name + "Status"] = "success";
          } else {
            sampleState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          break;
        }
      }
      sampleState[selectEvent.name] = event;
    } else if (event && event.target) {
      //Input Field
      switch (event.target.name) {
        case "sampleDate": {
          const value = event.target.value;

          if (value === "") {
            sampleState[event.target.name + "Status"] = "unchecked";
          } else {
            const isValid = Boolean(value) && !isNaN(new Date(value).getTime());
            sampleState[event.target.name + "Status"] = isValid
              ? "success"
              : "error";
          }

          sampleState[event.target.name] = value;
          break;
        }

        case "quantity": {
          const value = event.target.value;
          const numericValue = value;

          if (value === "") {
            sampleState[event.target.name + "Status"] = "unchecked";
          } else {
            const isValid =
              !isNaN(numericValue) &&
              numericValue >= 0 &&
              numericValue <= 100000000;
            sampleState[event.target.name + "Status"] = isValid
              ? "success"
              : "error";
          }
          sampleState[event.target.name] = value;
          break;
        }
      }

      sampleState[event.target.name] = event.target.value;
    }
    setSampleData(sampleState);
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      sampleData.quantityStatus === "success" &&
      sampleData.sampleDateStatus === "success" &&
      sampleData.customerNameStatus === "success" &&
      sampleData.productNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Sample Details"
                    : formType == "edit"
                    ? "Edit Sample Details"
                    : "View Sample Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Sample Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="productName"
                  options={productOptions}
                  value={sampleData.productName}
                  onChange={handleSampleForm}
                  success={sampleData.productNameStatus === "success"}
                  error={sampleData.productNameStatus === "error"}
                  isDisabled={inputDisable}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customerName"
                  value={sampleData.customerName}
                  options={customerOptions}
                  onChange={handleSampleForm}
                  isDisabled={inputDisable}
                  success={sampleData.customerNameStatus === "success"}
                  error={sampleData.customerNameStatus === "error"}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Sample Provided Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  name="sampleDate"
                  value={sampleData.sampleDate}
                  onChange={handleSampleForm}
                  disabled={inputDisable}
                  success={sampleData.sampleDateStatus === "success"}
                  error={sampleData.sampleDateStatus === "error"}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Quantity Provided <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="quantity"
                  type="number"
                  value={sampleData.quantity}
                  onChange={handleSampleForm}
                  disabled={inputDisable}
                  success={sampleData.quantityStatus === "success"}
                  error={sampleData.quantityStatus === "error"}
                />
                {sampleData.quantityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Quantity should be less than 100000000 units
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            mt={2}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/samples-and-feedback")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={
                  formType == "add" ? handleSubmitSample : handleEditSample
                }
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default SampleForm;
